module.exports = {
  "country": "NL",
  "artist": "Joost Klein",
  "song": "Europapa",
  "year": "2024",
  "place": "DQ",
  "spotify": "0uHrMbMv3c78398pIANDqR"
};